
import { slug } from 'utils/general'
/**
 * Used to display Brand tag on PDP, PLP and Quick View modal
 */
export default {
  computed: {
    brandTag () {
      let currentProduct = this.product.tags

      if (this.productObject) {
        currentProduct = this.productObject.tags
      }

      if (this.tags) {
        currentProduct = this.tags
      }

      const brandTagsGlobal = window.brandTags
      const brandTag = currentProduct.find(tag => slug(tag).includes('brand:'))

      if (brandTag) {
        const frontHandle = `@@${slug(brandTag)}@@`
        const backHandle = `##${slug(brandTag)}##`

        if (brandTagsGlobal.includes(frontHandle)) {
          const brandUrlAndTitle = brandTagsGlobal.split(frontHandle)[1].split(backHandle)[0]
          const brandUrl = brandUrlAndTitle.split('$$')[0]
          const brandTitle = brandUrlAndTitle.split('$$')[1]
          const payload = { url: brandUrl, text: brandTitle }

          this.$root.$emit('brandTagVisible', payload)

          return payload
        }

        return false
      }

      return false
    }
  }
}
